import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _cache[0] || (_cache[0] = _createElementVNode("main", { class: "container-fluid" }, [
      _createElementVNode("div", { class: "col-sm-12 col-md-6 offset-md-3 col-text" }, [
        _createElementVNode("h1", null, "Beta Testing"),
        _createElementVNode("p", null, "GanttProject Cloud is currently in beta testing. We are working on the final bits of its functionality and service monitoring."),
        _createElementVNode("p", null, "We invited a few users to the private beta and they are free to invite their colleagues. We do not charge for usage during private beta testing, provided that the usage is reasonable. However, we start charging as soon as we launch to the public.")
      ])
    ], -1))
  ]))
}